export default __webpack_public_path__ + "static/media/driver.7da518d7.svg";